const DELTA_POR_DEFECTO = 1;
const PUNTOS_SUSPENSIVOS = '...';
const CLASES_BASE_BOTON = 'px-3 py-2 rounded-lg text-sm font-medium transition';
const CLASES_BOTON_HABILITADO = 'bg-white text-gray-700 hover:bg-gray-50 border border-gray-300 hover:shadow-sm';
const CLASES_BOTON_DESHABILITADO = 'bg-gray-100 text-gray-400 cursor-not-allowed';

const COLORES_TEMA = {
  blue: 'bg-blue-600 hover:bg-blue-700 text-white shadow-md',
  green: 'bg-green-600 hover:bg-green-700 text-white shadow-md',
  red: 'bg-red-600 hover:bg-red-700 text-white shadow-md',
  yellow: 'bg-yellow-500 hover:bg-yellow-600 text-white shadow-md',
  purple: 'bg-purple-600 hover:bg-purple-700 text-white shadow-md',
  orange: 'bg-orange-600 hover:bg-orange-700 text-white shadow-md',
};

export default function Paginacion({ 
  paginacion, 
  alCambiarPagina, 
  cargando = false,
  nombreItem = 'registros',
  colorTema = 'blue',
  delta = DELTA_POR_DEFECTO
}) {
  if (!paginacion || paginacion.ultima_pagina <= 1) {
    return null;
  }

  const { pagina_actual, ultima_pagina, desde, hasta, total } = paginacion;

  const generarPaginas = () => {
    const paginas = [];

    paginas.push(1);

    const inicioRango = Math.max(2, pagina_actual - delta);
    const finRango = Math.min(ultima_pagina - 1, pagina_actual + delta);
    const hayHuecoIzquierda = inicioRango > 2;

    if (hayHuecoIzquierda) {
      paginas.push(PUNTOS_SUSPENSIVOS);
    }

    for (let i = inicioRango; i <= finRango; i++) {
      paginas.push(i);
    }

    const hayHuecoDerecha = finRango < ultima_pagina - 1;
    if (hayHuecoDerecha) {
      paginas.push(PUNTOS_SUSPENSIVOS);
    }

    if (ultima_pagina > 1) {
      paginas.push(ultima_pagina);
    }

    return paginas;
  };

  const paginas = generarPaginas();

  const renderizarBotonPagina = (numero, index) => {
    const esActivo = numero === pagina_actual;
    const clasesBoton = `${CLASES_BASE_BOTON} ${
      esActivo 
        ? COLORES_TEMA[colorTema] || COLORES_TEMA.blue
        : CLASES_BOTON_HABILITADO
    } ${cargando ? 'opacity-50 cursor-not-allowed' : ''}`;

    return (
      <button
        key={`pagina-${numero}-${index}`}
        onClick={() => alCambiarPagina(numero)}
        disabled={cargando}
        className={clasesBoton}
        aria-label={`Página ${numero}`}
        aria-current={esActivo ? 'page' : undefined}
      >
        {numero}
      </button>
    );
  };

  const renderizarPuntos = (index) => (
    <span
      key={`puntos-${index}`}
      className="px-2 py-2 text-gray-400 select-none"
      aria-hidden="true"
    >
      {PUNTOS_SUSPENSIVOS}
    </span>
  );

  const renderizarBotonNavegacion = ({ 
    onClick, 
    deshabilitado, 
    etiqueta, 
    ariaEtiqueta, 
    icono 
  }) => {
    const clasesBoton = `${CLASES_BASE_BOTON} ${
      deshabilitado 
        ? CLASES_BOTON_DESHABILITADO 
        : CLASES_BOTON_HABILITADO
    }`;

    return (
      <button
        onClick={onClick}
        disabled={deshabilitado}
        className={clasesBoton}
        aria-label={ariaEtiqueta}
        title={etiqueta}
      >
        {icono}
      </button>
    );
  };

  return (
    <div className="bg-white px-6 py-4 rounded-lg shadow">
      <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
        <div className="text-sm text-gray-600">
          Mostrando{' '}
          <span className="font-semibold">{desde || 0}</span> a{' '}
          <span className="font-semibold">{hasta || 0}</span> de{' '}
          <span className="font-semibold">{total || 0}</span> {nombreItem}
        </div>

        <nav 
          className="flex items-center gap-2" 
          role="navigation" 
          aria-label="Navegación de páginas"
        >
          {renderizarBotonNavegacion({
            onClick: () => alCambiarPagina(1),
            deshabilitado: pagina_actual === 1 || cargando,
            etiqueta: 'Primera página',
            ariaEtiqueta: 'Ir a la primera página',
            icono: '««'
          })}

          {renderizarBotonNavegacion({
            onClick: () => alCambiarPagina(pagina_actual - 1),
            deshabilitado: pagina_actual === 1 || cargando,
            etiqueta: 'Página anterior',
            ariaEtiqueta: 'Ir a la página anterior',
            icono: '«'
          })}

          <div className="flex items-center gap-1">
            {paginas.map((item, index) => 
              item === PUNTOS_SUSPENSIVOS 
                ? renderizarPuntos(index) 
                : renderizarBotonPagina(item, index)
            )}
          </div>

          {renderizarBotonNavegacion({
            onClick: () => alCambiarPagina(pagina_actual + 1),
            deshabilitado: pagina_actual === ultima_pagina || cargando,
            etiqueta: 'Página siguiente',
            ariaEtiqueta: 'Ir a la página siguiente',
            icono: '»'
          })}

          {renderizarBotonNavegacion({
            onClick: () => alCambiarPagina(ultima_pagina),
            deshabilitado: pagina_actual === ultima_pagina || cargando,
            etiqueta: 'Última página',
            ariaEtiqueta: 'Ir a la última página',
            icono: '»»'
          })}
        </nav>
      </div>
    </div>
  );
}
